import { Action } from 'redux';
import { AuthorizedRepresentative } from '../../angular-elements/shared/interfaces/enrollment-submission.interface';

export class AuthorizedRepresentativeAction implements Action {
  type: string;
  authorizedRepresentative?: AuthorizedRepresentative;
  ctrlName?: string;
}

const INITIAL_STATE: AuthorizedRepresentative = {};
export const RESET_AUTHREP_CONTROL = 'RESET_AUTHREP_CONTROL';
export const LOAD_AUTHORIZED_REPRESENTATIVE = 'LOAD_AUTHORIZED_REPRESENTATIVE';
const RESET_STATE = 'RESET_STATE_AuthRep';

export function loadAuthorizedRepresentative(authorizedRepresentative: AuthorizedRepresentative): AuthorizedRepresentativeAction {
  return { type: LOAD_AUTHORIZED_REPRESENTATIVE, authorizedRepresentative };
}

export function resetAuthRepControl(controlName: string): AuthorizedRepresentativeAction {
  return {
    type: RESET_AUTHREP_CONTROL,
    ctrlName: controlName
  };
}

export function resetAuthRep(): AuthorizedRepresentativeAction {
  return { type: RESET_STATE };
}

export function AuthorizedRepresentative( state: AuthorizedRepresentative = INITIAL_STATE, action: AuthorizedRepresentativeAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case RESET_AUTHREP_CONTROL:
      if (copiedState[action.ctrlName]) {
        copiedState[action.ctrlName] = '';
      }
      return Object.assign({}, state, copiedState);
    case LOAD_AUTHORIZED_REPRESENTATIVE:
      copiedState.firstName = action.authorizedRepresentative.firstName;
      copiedState.middleInitial = action.authorizedRepresentative.middleInitial;
      copiedState.lastName = action.authorizedRepresentative.lastName;
      copiedState.suffix = action.authorizedRepresentative.suffix;
      copiedState.addressLine1 = action.authorizedRepresentative.addressLine1;
      copiedState.addressLine2 = action.authorizedRepresentative.addressLine2;
      copiedState.city = action.authorizedRepresentative.city;
      copiedState.state = action.authorizedRepresentative.state;
      copiedState.zipCode = action.authorizedRepresentative.zipCode;
      copiedState.phoneNumber = action.authorizedRepresentative.phoneNumber;
      return Object.assign({}, state, copiedState);
    case RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
}

